import clsx from 'clsx';
import { Button } from '../../../../Button';
import { useAuthUrlsContext } from '../../AuthUrlsProvider';

export function JoinButton() {
  const { signUpUrl } = useAuthUrlsContext();

  return (
    <Button
      variant="outlined"
      component="a"
      href={signUpUrl}
      className={clsx('inline-block', 'sm:hidden')}
    >
      Join
    </Button>
  );
}
